export function identificarCodigoPais(numero) {
  // Limpiamos el número: quitamos espacios, guiones, paréntesis, etc.
  const limpio = numero.replace(/[^0-9+]/g, "");

  // Lista de códigos válidos
  const codigos = {
    591: "Bolivia",
    55: "Brasil",
    51: "Perú",
  };

  // Extraer si comienza con "+"
  let codigoLimpio = limpio.startsWith("+") ? limpio.slice(1) : limpio;

  // Intentamos detectar el país
  for (const codigo in codigos) {
    if (codigoLimpio.startsWith(codigo)) {
      return {
        tieneCodigoPais: true,
        codigo: codigo,
        pais: codigos[codigo],
        numeroLocal: codigoLimpio.slice(codigo.length),
      };
    }
  }

  // Si no comienza con un código conocido
  return {
    tieneCodigoPais: false,
    codigo: null,
    pais: null,
    numeroLocal: limpio,
  };
}
